import React from 'react';
import CTA from './CTA';
import FAQ from './FAQ';
import useConfig from '@hooks/useConfig';

export default React.memo(function BottomContent({ faqs, ctas }) {
  const { positionCtaBelowFaq } = useConfig();

  const content = [
    <CTA
      key="cta"
      items={ctas}
    />,
    <FAQ
      key="faq"
      items={faqs}
    />
  ];

  if (positionCtaBelowFaq) {
    content.reverse();
  }

  return <div id="calculator-bottom">{content}</div>;
});
